import React, { useState } from 'react'
import { Dropdown, Button } from 'antd'
import { DownOutlined } from '@ant-design/icons'

export interface DropdownNavigationItem {
  key: string
  matchKeys?: string[]
  label: string
  onClick: () => void
}

interface DropdownNavigationProps {
  title: string
  currentPage: string
  onTitleClick?: () => void
  showNew?: boolean
  badgeText?: string
  items: DropdownNavigationItem[]
}

const DropdownNavigation: React.FC<DropdownNavigationProps> = ({
  title,
  currentPage,
  onTitleClick,
  showNew = false,
  badgeText,
  items
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const matchesItem = (item: { key: string; matchKeys?: string[] }) => {
    const matchKeys = item.matchKeys || [item.key]
    return matchKeys.includes(currentPage)
  }

  // 判断当前页面是否属于该菜单
  const isActive = items.some(matchesItem)

  const dropdownItems = items.map(item => {
    const isItemActive = matchesItem(item)
    return {
      key: item.key,
      label: (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px',
          color: isItemActive ? '#2563eb' : '#374151',
          fontWeight: isItemActive ? '600' : '400'
        }}>
          <span>{item.label}</span>
          {isItemActive && (
            <span style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              backgroundColor: '#2563eb'
            }} />
          )}
        </div>
      ),
      onClick: () => {
        item.onClick()
        setIsOpen(false)
      }
    }
  })

  const handleTitleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (onTitleClick) {
      onTitleClick()
      setIsOpen(false)
    }
  }

  return (
    <div
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      style={{ display: 'inline-block' }}
    >
      <Dropdown
        menu={{ items: dropdownItems }}
        placement="bottomLeft"
        open={isOpen}
        onOpenChange={(open) => setIsOpen(open)}
        popupRender={(menu) => (
          <div style={{ marginTop: '-4px', paddingTop: '8px' }}>
            {menu}
          </div>
        )}
      >
        <Button
          type="text"
          style={{
            color: isActive ? '#2563eb' : '#6b7280',
            fontWeight: '500',
            fontSize: '16px',
            whiteSpace: 'nowrap',
            transition: 'color 0.3s ease',
            padding: '0',
            height: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            position: 'relative'
          }}
          className="nav-link"
          onClick={handleTitleClick}
          onMouseEnter={(e) => {
            if (!isActive) {
              e.currentTarget.style.color = '#2563eb'
            }
          }}
          onMouseLeave={(e) => {
            if (!isActive) {
              e.currentTarget.style.color = '#6b7280'
            }
          }}
        >
          {title}
          {(showNew || badgeText) && (
            <span style={{
              position: 'absolute',
              top: '-8px',
              right: '-32px',
              fontSize: '8px',
              fontWeight: '600',
              color: '#ffffff',
              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
              padding: '1px 4px',
              borderRadius: '3px',
              textTransform: 'uppercase',
              letterSpacing: '0.3px',
              boxShadow: '0 1px 3px rgba(239, 68, 68, 0.3)',
              whiteSpace: 'nowrap',
              transform: 'scale(0.9)',
            }}>
              {badgeText || 'NEW'}
            </span>
          )}
          <DownOutlined
            style={{
              fontSize: '12px',
              color: isActive ? '#2563eb' : '#9ca3af',
              transition: 'transform 0.3s ease',
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
            }}
          />
        </Button>
      </Dropdown>
    </div>
  )
}

export default DropdownNavigation
